export default "__VITE_ASSET__D9r1aGaa__"